import { Pipe, PipeTransform } from "@angular/core";
import { environment } from "../../environments/environment";

@Pipe({
  name: "imgBat",
})
export class ImgBatPipe implements PipeTransform {
  transform(uuid: string, custom: boolean, trophy: boolean): any {
    if (custom && !trophy) return "assets/imgs/cutom-bat.png";
    return `${environment.apiUrl}/ecommerce/getImage?name=${uuid}`;
  }
}
